import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { CreateSkLkrlStoreService } from './create-sk-lkrl.service';
import { CreateSkLkrlStoreModule } from '@common/store/create-sk-lkrl';

@NgModule({
  providers: [CreateSkLkrlStoreService],
  imports: [CreateSkLkrlStoreModule, EffectsModule.forRoot()],
})
export class CreateSkLkrlStoreServiceModule {}
